const env = process.env.NODE_ENV
// var url = 'http://com.aojv.cj:19091/interview';
// var url = 'http://192.168.2.75:19091/interview'; 
var url = 'https://train.aojuai.com/interview';
const config = {
  development:{
    // baseURL :url//本地
    baseURL :url //线上 
  },
  production:{
     baseURL :'https://train.aojuai.com/interview'
  }
}
export default {
  baseURL:config[env].baseURL
}